import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-width: 300px;
        span {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-top: 10px;
                        `,
                        css`
                            null,
                        `,
                        css`
                        null,
                        `,
                        css`
                        null,
                    `,
                        css`
                        null,
                    `,
                    ],
                    "max",
                )}
            img {
                height: auto;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 200px;
                            `,
                            css`
                                width: 200px;
                            `,
                            css`
                                width: 200px;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }
        }
    `,
};
